// extracted by mini-css-extract-plugin
module.exports = {"project__content":"problem-section_project__content__6KPMb"};